import { Head, Link, router } from "@inertiajs/react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { useEffect, useState } from "react";

const STATUS_LABELS = {
  done: "Terminé",
  waiting: "En attente",
  failed: "Échoué",
};

const STATUS_COLORS = {
  done: "bg-emerald-100 text-emerald-700 hover:bg-emerald-100",
  waiting: "bg-amber-100 text-amber-700 hover:bg-amber-100",
  failed: "bg-red-100 text-red-700 hover:bg-red-100",
};

export default function JobsIndex({ jobs, pending_count }) {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [expandedJob, setExpandedJob] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsRefreshing(true);
      router.reload({
        only: ["jobs", "pending_count"],
        onFinish: () => setIsRefreshing(false),
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="p-6">
      <Head title="Jobs" />
      <div className="flex items-center gap-4 mb-6">
        <Link href="/admin" className="text-blue-600 hover:underline">
          ← Retour
        </Link>
        <h1 className="text-2xl font-bold">Jobs</h1>
        {pending_count === 0 ? (
          <Badge className="bg-emerald-100 text-emerald-700">Tous les jobs ont été traités</Badge>
        ) : (
          <Badge className="bg-amber-100 text-amber-700">{pending_count} en attente de traitement</Badge>
        )}
        {isRefreshing && (
          <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
        )}
      </div>

      {jobs.length === 0 ? (
        <p className="text-gray-500">Aucun job trouvé.</p>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Nom</TableHead>
              <TableHead>Planifié le</TableHead>
              <TableHead>Terminé le</TableHead>
              <TableHead>Statut</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {jobs.map((job) => (
              <>
                <TableRow
                  key={job.id}
                  className={job.error ? "cursor-pointer" : ""}
                  onClick={() => job.error && setExpandedJob(expandedJob === job.id ? null : job.id)}
                >
                  <TableCell className="font-mono text-sm">{job.name}</TableCell>
                  <TableCell>{job.scheduled_at || "—"}</TableCell>
                  <TableCell>{job.finished_at || "—"}</TableCell>
                  <TableCell>
                    <Badge className={STATUS_COLORS[job.status]}>{STATUS_LABELS[job.status]}</Badge>
                  </TableCell>
                </TableRow>
                {expandedJob === job.id && job.error && (
                  <TableRow key={`${job.id}-error`}>
                    <TableCell colSpan={4} className="bg-red-50 p-4">
                      <pre className="text-xs text-red-800 whitespace-pre-wrap font-mono overflow-x-auto">
                        {job.error}
                      </pre>
                    </TableCell>
                  </TableRow>
                )}
              </>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
